
export const businessPresets = {
  'restaurant-food-service': {
    serviceTemplates: [
      { name: 'Table for 2', duration: 60 },
      { name: 'Table for 4', duration: 60 },
      { name: 'Private Dining', duration: 120 },
      { name: 'Catering Consultation', duration: 30 },
    ],
    businessHours: {
      monday: [{ start: '11:00', end: '15:00' }, { start: '17:00', end: '22:00' }],
      tuesday: [{ start: '11:00', end: '15:00' }, { start: '17:00', end: '22:00' }],
      wednesday: [{ start: '11:00', end: '15:00' }, { start: '17:00', end: '22:00' }],
      thursday: [{ start: '11:00', end: '15:00' }, { start: '17:00', end: '22:00' }],
      friday: [{ start: '11:00', end: '15:00' }, { start: '17:00', end: '23:00' }],
      saturday: [{ start: '10:00', end: '23:00' }],
      sunday: [{ start: '10:00', end: '21:00' }],
    },
    bookingRules: {
      bufferTime: 15, // minutes between bookings
      leadTime: 60, // require booking at least 60 minutes in advance
      futureBookingLimit: 90, // days in advance
    },
    customFields: [
      { name: 'Number of Guests', type: 'number', required: true },
      { name: 'Dietary Restrictions', type: 'text', required: false },
      { name: 'Special Occasion', type: 'text', required: false },
    ],
  },
  'fitness-wellness': {
    serviceTemplates: [
      { name: 'Personal Training', duration: 60 },
      { name: 'Group Class', duration: 45 },
      { name: 'Fitness Assessment', duration: 30 },
      { name: 'Nutrition Consultation', duration: 30 },
    ],
    businessHours: {
      monday: [{ start: '06:00', end: '21:00' }],
      tuesday: [{ start: '06:00', end: '21:00' }],
      wednesday: [{ start: '06:00', end: '21:00' }],
      thursday: [{ start: '06:00', end: '21:00' }],
      friday: [{ start: '06:00', end: '20:00' }],
      saturday: [{ start: '08:00', end: '18:00' }],
      sunday: [{ start: '09:00', end: '16:00' }],
    },
    bookingRules: {
      bufferTime: 10,
      leadTime: 120,
      futureBookingLimit: 60,
    },
    customFields: [
      { name: 'Fitness Goal', type: 'text', required: true },
      { name: 'Experience Level', type: 'select', options: ['Beginner', 'Intermediate', 'Advanced'], required: true },
    ],
  },
  'healthcare-medical': {
    serviceTemplates: [
      { name: 'General Consultation', duration: 30 },
      { name: 'Check-up', duration: 45 },
      { name: 'Procedure', duration: 60 },
      { name: 'Follow-up', duration: 15 },
    ],
    businessHours: {
      monday: [{ start: '08:30', end: '17:00' }],
      tuesday: [{ start: '08:30', end: '17:00' }],
      wednesday: [{ start: '08:30', end: '17:00' }],
      thursday: [{ start: '08:30', end: '17:00' }],
      friday: [{ start: '08:30', end: '16:00' }],
      saturday: [],
      sunday: [],
    },
    bookingRules: {
      bufferTime: 5,
      leadTime: 1440, // 24 hours in minutes
      futureBookingLimit: 180,
    },
    customFields: [
      { name: 'Reason for Visit', type: 'textarea', required: true },
      { name: 'New Patient?', type: 'checkbox', required: true },
      { name: 'Insurance Provider', type: 'text', required: false },
    ],
  },
  'beauty-wellness': {
    serviceTemplates: [
      { name: 'Haircut & Style', duration: 60 },
      { name: 'Hair Color', duration: 120 },
      { name: 'Manicure', duration: 45 },
      { name: 'Facial', duration: 60 },
    ],
    businessHours: {
      monday: [],
      tuesday: [{ start: '09:00', end: '18:00' }],
      wednesday: [{ start: '09:00', end: '18:00' }],
      thursday: [{ start: '10:00', end: '20:00' }],
      friday: [{ start: '09:00', end: '19:00' }],
      saturday: [{ start: '08:00', end: '16:00' }],
      sunday: [],
    },
    bookingRules: {
      bufferTime: 15,
      leadTime: 180,
      futureBookingLimit: 90,
    },
    customFields: [
      { name: 'Preferred Stylist', type: 'text', required: false },
      { name: 'Hair Type', type: 'text', required: false },
      { name: 'Allergies', type: 'text', required: false },
    ],
  },
  'automotive-services': {
    serviceTemplates: [
      { name: 'Oil Change', duration: 30 },
      { name: 'Brake Service', duration: 90 },
      { name: 'Diagnostic', duration: 60 },
      { name: 'Tire Service', duration: 45 },
    ],
    businessHours: {
      monday: [{ start: '08:00', end: '17:30' }],
      tuesday: [{ start: '08:00', end: '17:30' }],
      wednesday: [{ start: '08:00', end: '17:30' }],
      thursday: [{ start: '08:00', end: '17:30' }],
      friday: [{ start: '08:00', end: '17:30' }],
      saturday: [{ start: '09:00', end: '13:00' }],
      sunday: [],
    },
    bookingRules: {
      bufferTime: 0,
      leadTime: 60,
      futureBookingLimit: 45,
    },
    customFields: [
      { name: 'Vehicle Make', type: 'text', required: true },
      { name: 'Vehicle Model', type: 'text', required: true },
      { name: 'Vehicle Year', type: 'number', required: true },
      { name: 'VIN', type: 'text', required: false },
    ],
  },
  'education-tutoring': {
    serviceTemplates: [
      { name: 'Tutoring Session', duration: 60 },
      { name: 'Assessment', duration: 90 },
      { name: 'Workshop', duration: 120 },
      { name: 'Parent Meeting', duration: 30 },
    ],
    businessHours: {
      monday: [{ start: '15:00', end: '20:00' }],
      tuesday: [{ start: '15:00', end: '20:00' }],
      wednesday: [{ start: '15:00', end: '20:00' }],
      thursday: [{ start: '15:00', end: '20:00' }],
      friday: [{ start: '15:00', end: '19:00' }],
      saturday: [{ start: '10:00', end: '16:00' }],
      sunday: [],
    },
    bookingRules: {
      bufferTime: 5,
      leadTime: 1440,
      futureBookingLimit: 90,
    },
    customFields: [
      { name: 'Student Name', type: 'text', required: true },
      { name: 'Grade Level', type: 'text', required: true },
      { name: 'Subject', type: 'text', required: true },
      { name: 'Learning Goals', type: 'textarea', required: false },
    ],
  },
  'technology-consulting': {
    serviceTemplates: [
      { name: 'IT Consultation', duration: 60 },
      { name: 'Software Demo', duration: 45 },
      { name: 'Project Scoping', duration: 90 },
    ],
    businessHours: {
      monday: [{ start: '09:00', end: '18:00' }],
      tuesday: [{ start: '09:00', end: '18:00' }],
      wednesday: [{ start: '09:00', end: '18:00' }],
      thursday: [{ start: '09:00', end: '18:00' }],
      friday: [{ start: '09:00', end: '17:00' }],
      saturday: [],
      sunday: [],
    },
    bookingRules: {
      bufferTime: 15,
      leadTime: 1440,
      futureBookingLimit: 90,
    },
    customFields: [
      { name: 'Area of Interest', type: 'text', required: true },
      { name: 'Company Size', type: 'number', required: false },
    ],
  },
  'legal-finance': {
    serviceTemplates: [
      { name: 'Legal Consultation', duration: 60 },
      { name: 'Financial Planning', duration: 90 },
      { name: 'Document Review', duration: 45 },
    ],
    businessHours: {
      monday: [{ start: '09:00', end: '17:00' }],
      tuesday: [{ start: '09:00', end: '17:00' }],
      wednesday: [{ start: '09:00', end: '17:00' }],
      thursday: [{ start: '09:00', end: '17:00' }],
      friday: [{ start: '09:00', end: '17:00' }],
      saturday: [],
      sunday: [],
    },
    bookingRules: {
      bufferTime: 0,
      leadTime: 2880,
      futureBookingLimit: 180,
    },
    customFields: [
      { name: 'Nature of Inquiry', type: 'textarea', required: true },
    ],
  },
  'home-services': {
    serviceTemplates: [
      { name: 'Cleaning', duration: 120 },
      { name: 'Repair', duration: 60 },
      { name: 'Maintenance', duration: 45 },
    ],
    businessHours: {
      monday: [{ start: '08:00', end: '17:00' }],
      tuesday: [{ start: '08:00', end: '17:00' }],
      wednesday: [{ start: '08:00', end: '17:00' }],
      thursday: [{ start: '08:00', end: '17:00' }],
      friday: [{ start: '08:00', end: '17:00' }],
      saturday: [],
      sunday: [],
    },
    bookingRules: {
      bufferTime: 30,
      leadTime: 1440,
      futureBookingLimit: 60,
    },
    customFields: [
      { name: 'Service Address', type: 'text', required: true },
      { name: 'Specific Instructions', type: 'textarea', required: false },
    ],
  },
  'pet-services': {
    serviceTemplates: [
      { name: 'Grooming', duration: 90 },
      { name: 'Walking', duration: 30 },
      { name: 'Boarding', duration: 1440 },
    ],
    businessHours: {
      monday: [{ start: '08:00', end: '18:00' }],
      tuesday: [{ start: '08:00', end: '18:00' }],
      wednesday: [{ start: '08:00', end: '18:00' }],
      thursday: [{ start: '08:00', end: '18:00' }],
      friday: [{ start: '08:00', end: '18:00' }],
      saturday: [{ start: '09:00', end: '17:00' }],
      sunday: [],
    },
    bookingRules: {
      bufferTime: 15,
      leadTime: 240,
      futureBookingLimit: 60,
    },
    customFields: [
      { name: 'Pet Name', type: 'text', required: true },
      { name: 'Pet Breed', type: 'text', required: true },
    ],
  },
  'event-planning': {
    serviceTemplates: [
      { name: 'Consultation', duration: 60 },
      { name: 'Planning Session', duration: 120 },
      { name: 'Coordination', duration: 240 },
    ],
    businessHours: {
      monday: [{ start: '09:00', end: '17:00' }],
      tuesday: [{ start: '09:00', end: '17:00' }],
      wednesday: [{ start: '09:00', end: '17:00' }],
      thursday: [{ start: '09:00', end: '17:00' }],
      friday: [{ start: '09:00', end: '17:00' }],
      saturday: [],
      sunday: [],
    },
    bookingRules: {
      bufferTime: 0,
      leadTime: 4320,
      futureBookingLimit: 365,
    },
    customFields: [
      { name: 'Event Type', type: 'text', required: true },
      { name: 'Estimated Guests', type: 'number', required: true },
    ],
  },
  'other': {
    serviceTemplates: [
      { name: 'Appointment', duration: 60 },
      { name: 'Consultation', duration: 30 },
      { name: 'Meeting', duration: 45 },
    ],
    businessHours: {
      monday: [{ start: '09:00', end: '17:00' }],
      tuesday: [{ start: '09:00', end: '17:00' }],
      wednesday: [{ start: '09:00', end: '17:00' }],
      thursday: [{ start: '09:00', end: '17:00' }],
      friday: [{ start: '09:00', end: '17:00' }],
      saturday: [],
      sunday: [],
    },
    bookingRules: {
      bufferTime: 10,
      leadTime: 60,
      futureBookingLimit: 90,
    },
    customFields: [
      { name: 'Reason for Appointment', type: 'textarea', required: true },
    ],
  },
};

export const getBusinessPreset = (businessType) => {
  return businessPresets[businessType] || null;
};
